import React, { useState, useEffect } from 'react';
import Login from './Login';
import Home from './Home';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Loader } from '@mantine/core';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('jwt_token');
  };

  useEffect(() => {
    const token = localStorage.getItem('jwt_token');
    if (token && !user) {
      setLoading(true);
      fetch('/api/verify', {
        headers: { 'Authorization': 'Bearer ' + token }
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setUser(data.user);
          } else {
            localStorage.removeItem('jwt_token');
          }
        })
        .catch(() => {
          localStorage.removeItem('jwt_token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return (
      <Box style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader size="lg" />
      </Box>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to={location.state?.from || '/'} replace /> : <Login onLogin={handleLogin} />
      } />
      <Route path="/*" element={
        user ? <Home user={user} onLogout={handleLogout} /> : <Navigate to="/login" state={{ from: location.pathname }} replace />
      } />
    </Routes>
  );
}

export default App;
